import { AxiosError } from 'axios';
import { ErrorResponseErrorCode } from '@/entities/system/api/generated/model/errorResponseErrorCode';

/**
 * トークン制限超過エラー（402 + TOKEN_LIMIT_EXCEEDED）かどうかを判定する
 */
export const isTokenLimitError = (error: unknown): boolean =>
  error instanceof AxiosError &&
  error.response?.status === 402 &&
  (error.response?.data as { error_code?: string })?.error_code ===
    ErrorResponseErrorCode.TOKEN_LIMIT_EXCEEDED;
